import React from "react";

import { Button, Dropdown, Form, Input } from "semantic-ui-react";

import { useIntl } from "react-intl";

import DateTextBox from "react-lib/apps/common/DateTextBox";

export type UserProfileBasicType = Partial<{
  birthdate: string | null;
  first_name: string;
  last_name: string;
  licence: string;
  position: string;
  user: string;
}>;

export type LoginInfo = {
  emailLogin?: string;
  facebookName?: string;
  isEmailLogin?: boolean;
  isFacebookLogin?: boolean;
  isJustLogin?: boolean;
  isLineLogin?: boolean;
  lineId?: string;
  loginDisplay?: {
    label: string;
    method: string;
    value: string;
  };
};

type UserProfileFormBasicProps = {
  isSaveLoading: boolean;
  loginInfo: LoginInfo;
  userData: UserProfileBasicType;
  positionOptions: any[];
  onChangeValue: (e: any, data: any) => void;
  onSave: () => void;
};

const UserProfileFormBasic: React.FC<UserProfileFormBasicProps> = (props) => {
  const intl = useIntl();

  return (
    <Form>
      <Form.Field inline>
        <label className="reg">IH ID</label>
        <Input
          className="reg"
          placeholder={intl.formatMessage({ id: "IH ID (ตัวเลข)" })}
          value={props.userData.user}
          readOnly
        />
      </Form.Field>

      {!!props.loginInfo.loginDisplay?.method && (
        <>
          <Form.Field inline>
            <label className="reg">{intl.formatMessage({ id: "Login ด้วย" })}</label>
            <Input className="reg" value={props.loginInfo.loginDisplay.method} readOnly />
          </Form.Field>
          <Form.Field inline>
            <label className="reg">{props.loginInfo.loginDisplay.label}</label>
            <input className="reg" value={props.loginInfo.loginDisplay.value} readOnly />
          </Form.Field>
        </>
      )}

      <Form.Field inline required>
        <label className="reg">{intl.formatMessage({ id: "ชื่อ" })}</label>
        <Input
          className="reg"
          name="first_name"
          value={props.userData.first_name}
          onChange={props.onChangeValue}
        />
      </Form.Field>

      <Form.Field inline required>
        <label className="reg">{intl.formatMessage({ id: "นามสกุล" })}</label>
        <Input
          className="reg"
          name="last_name"
          value={props.userData.last_name}
          onChange={props.onChangeValue}
        />
      </Form.Field>

      <Form.Field inline required>
        <label className="reg">{intl.formatMessage({ id: "เลขที่ใบประกอบวิชาชีพ" })}</label>
        <Input
          style={{ width: "200px" }}
          name="licence"
          value={props.userData.licence}
          onChange={props.onChangeValue}
        />
      </Form.Field>

      <Form.Field inline required>
        <label className="reg">{intl.formatMessage({ id: "วันเกิด" })}</label>
        <DateTextBox
          value={props.userData.birthdate}
          onChange={(value) => {
            props.onChangeValue(null, { name: "birthdate", value });
          }}
        />
      </Form.Field>

      <Form.Field inline required>
        <label className="reg">{intl.formatMessage({ id: "ตำแหน่ง" })}</label>
        <Dropdown
          style={{ width: "200px" }}
          name="position"
          value={props.userData.position}
          scrolling
          options={props.positionOptions}
          onChange={props.onChangeValue}
        />
      </Form.Field>

      <br />
      <div className="last-div">
        <Button
          style={{ backgroundColor: "var(--primary-theme-color)", color: "white" }}
          loading={props.isSaveLoading}
          type="submit"
          onClick={props.onSave}
        >
          บันทึก
        </Button>
      </div>
    </Form>
  );
};

export default UserProfileFormBasic;
